import { langFallback$Fetch } from '~/lang/utils/langfetch'
import { keysToCamel } from '~/utility/toCamel'
import { PayPalCallbackParams, PayPalCallbackServiceOutput } from './schema'
import { PayPalCallbackService } from './services'

export class PayPalCallbackServiceFetch extends PayPalCallbackService {
  async get(
    { bookingId, token, payerId }: PayPalCallbackParams,
    langCode: string,
  ): Promise<PayPalCallbackServiceOutput> {
    const response = await langFallback$Fetch(
      langCode,
      `/booking/paypal_callback/${bookingId}/?format=json&token=${token}&PayerID=${payerId}`,
    )
    return keysToCamel(response)
  }
}
